module.exports = __webpack_public_path__ + "static/media/gallery8.7b435cff.png";